<template>
  <b-row class="rounded m-0 suscribeBar">
    <b-col class="col-12 col-md-7">
      <b-input-group v-if="newslettersend === 0">
        <b-form-input
          class="bg-transparent"
          placeholder="Email"
          type="email"
          v-model="newslettermail"
        ></b-form-input>
        <b-input-group-append>
          <b-button @click="sendNewsletter()">
            <b-icon icon="chevron-right" />
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <b-alert show variant="dark" v-else-if="newslettersend === 1">Enviando tu solicitud. Un momento por favor.</b-alert>
      <b-alert show variant="success" v-else >Tu solicitud ha sido enviada. ¡Gracias por suscribirte!</b-alert>
    </b-col>
    <b-col class="d-none d-md-block" style="font-weight: bold;"
      >Suscribite al newsletter y recibí las novedades de la editorial y de la
      librería</b-col
    >
  </b-row>
</template>
<script>
import axios from "axios";

export default {
  data: function() {
    return {
      newslettersend: 0,
      newslettermail: null
    };
  },
  methods: {
    async sendNewsletter(){
      if (this.newslettermail === null || this.newslettermail === ''){
        this.$bvModal.msgBoxOk('Por favor ingresa una casilla de email para enviar tu solicitud', {
            title: 'Error',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'success',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true
            });
          
          return;
      }
      this.newslettersend = 1;
      await axios
        .post(
          this.$store.state.user.siteData.location + "newsletter/newsletter/save",
          JSON.stringify({ mail: this.newslettermail, client: this.$store.state.user.usrid }),
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          this.newslettersend = 2;
          console.log(evtResponse)
        });


    }
  }
}
</script>